<template>
  <ul class="nav justify-content-center wizard">
    <template v-for="step in steps">
      <li class="nav-item" :key="step.number">
        <a class="nav-link nav-link--text disabled" href="" @click.prevent="">
          <span
            class="kt-badge kt-badge--light kt-badge--lg font-weight-bold iconSteps"
            :class="(currentStep === step.number) ? 'kt-badge--brand' : 'kt-badge--outline'"
            style="border-width: 3px;">{{ step.number }}</span>&nbsp;
          <span class="fw-500 text-white stepName">{{ step.label }}</span>
        </a>
      </li>
      <li class="nav-item nav-item--divider" :key="step.label"></li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'Wizard',
  props: {
    steps: {
      type: Array,
      required: true
    },
    currentStep: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.nav.justify-content-center{
  margin: 2.5rem 0;
}
.nav-item {
  position: relative;
}
.nav-item--divider::before {
  position: relative;
  content: '';
  width: 200px;
  height: 1px;
  background: #fff;
  display: block;
  top: 50%;
  box-shadow: 0 0 1px #ddd;
  opacity: .52;
}
.nav-item:last-child {
  display: none;
}
@media (max-width: 767.98px) {
  .nav-item--divider::before {
    width: 50px;
  }
}
.nav-link {
  padding: 0.5rem 3rem !important;
}
.nav-link--text span {
  text-shadow: 0 0 1px #ddd;
}
.kt-badge {
  box-shadow: 0 0 1px #ddd;
}
.iconSteps{
    font-size: 1rem!important;
    height: 25px!important;
    width: 25px!important;
}
.kt-badge--brand + .stepName{
    font-size: 1.3em;
}
.kt-badge--outline, .kt-badge--outline + .stepName{
    opacity: .52;
}
.stepName {
    margin-left: 0.5rem;
    vertical-align: middle;
}
</style>
